"use client";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useDebounce } from "@/hooks/useDebounce";
import { cn } from "@/lib/utils";
import { SearchIcon } from "lucide-react";
import { useRouter, useSearchParams } from "next/navigation";
import React, { useState, useEffect } from "react";

const Search = ({
  name = "search",
  className,
  labelClassName,
  placeholder = "Cari",
  label,
  widthFull = false,
}: {
  name?: string;
  className?: string;
  labelClassName?: string;
  placeholder?: string;
  label?: string;
  widthFull?: boolean;
}) => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const [query, setQuery] = useState(searchParams.get(name) || "");

  const debouncedValues = useDebounce({ value: query, delay: 400 });

  useEffect(() => {
    const currentParams = new URLSearchParams(searchParams.toString());
    if (debouncedValues.trim()) {
      currentParams.set(name, debouncedValues);
    } else {
      currentParams.delete(name);
    }
    router.push(`?${currentParams.toString()}`, { scroll: false });
  }, [name, router, searchParams, debouncedValues]);

  return (
    <div className={cn("", widthFull && "w-full")}>
      {label && (
        <Label className={cn("font-medium mb-1", labelClassName)}>
          {label}
        </Label>
      )}
      <div className={cn("relative flex items-center", className)}>
        <SearchIcon className="absolute left-2" />
        <Input
          placeholder={placeholder}
          className="pl-10 bg-white border border-border h-[2.6rem]"
          onChange={(e) => setQuery(e.target.value)}
          value={query}
        />
      </div>
    </div>
  );
};

export default Search;
